import { SortedSource } from './SortedSource.js';
export class SortedWritableSource extends SortedSource {
    add(settings) {
        super.add(settings);
    }
}
//# sourceMappingURL=SortedWritableSource.js.map